import _get from 'lodash/get'
import strictUriEncode from 'strict-uri-encode'
import { post as apiPost, get as apiGet, put as apiPut, TYPE_BROOKLYN_JSON } from 'api-client'

export const PLAYLIST_EDIT_COMPLETE = 'playlistEditComplete'
export const PLAYLIST_TYPE_DEFAULT = 'default'

export const PLAYLIST_PORTAL_LIMIT = 15

export const PLAYLIST_TYPES = {
  RECENTLY_WATCHED: 'recent',
  USER: 'user',
}

export const PLAYLIST_DROPDOWN_OPTIONS = [
  {
    label: 'Recently Watched',
    value: PLAYLIST_TYPES.RECENTLY_WATCHED,
  },
  {
    label: 'My Playlist',
    value: PLAYLIST_TYPES.USER,
  },
  {
    label: 'Choose Playlist',
    value: 'default',
  },
]

export async function getPlaylistItem ({ auth, contentId }) {
  const url = `v1/playlists/content/${contentId}`
  const result = await apiGet(url, null, { auth }, TYPE_BROOKLYN_JSON)
  return _get(result, ['body'], {})
}

export async function updatePlaylist ({ auth, type, name }) {
  const url = `v2/playlists/${type}`
  const result = await apiPut(url, { name }, { auth }, TYPE_BROOKLYN_JSON)
  return _get(result, ['body'], {})
}

export async function updatePlaylistItem ({ auth, contentId, type, add }) {
  const action = add ? 'add' : 'remove'
  const url = `v2/playlists/${type}/${action}/${strictUriEncode(contentId)}`
  const result = await apiPost(url, null, { auth }, TYPE_BROOKLYN_JSON)
  const handledRes = handleInPlaylistResponse(result)
  return handledRes ? _get(result, ['body'], {}) : {}
}

export async function updatePlaylistItemPosition ({
  auth,
  contentId,
  playlistId,
  playlistPosition,
}) {
  const url = `v3/playlists/content/${strictUriEncode(contentId)}`

  const result = await apiPut(
    url,
    {
      playlistId,
      playlistPosition,
      playlistType: 'portal',
    },
    {
      auth,
    }, TYPE_BROOKLYN_JSON)
  return _get(result, ['body'], {})
}

// ------------------------------------
// OLD functions used on PlaylistPage
// ------------------------------------

export function handleInPlaylistResponse (res) {
  const success = _get(res, ['body', 'success'])
  if (!success) {
    throw new Error('The playlist information failed to save. Please try again.')
  }
  return success
}

export function setInPlaylist (options) {
  const { id, inPlaylist, auth } = options
  // if inPlaylist is true, add to playlist, otherwise remove
  const action = inPlaylist ? 'add' : 'remove'
  const url = `v2/playlists/default/${action}/${strictUriEncode(id)}`
  return apiPost(url, null, { auth }, TYPE_BROOKLYN_JSON)
    .then((res) => {
      return handleInPlaylistResponse(res)
    })
}

// ------------------------------------
// Fetch Playlists
// ------------------------------------
export async function getUserPlaylist ({ auth, page = 1, limit }) {
  // Endpoint pagination returns 0 as the first page by default.
  // We do not want user's to see this so we control the offset here
  const offsetPage = page - 1

  const res = await apiGet('/v2/playlists/default',
    { p: offsetPage, pp: limit },
    { auth },
    TYPE_BROOKLYN_JSON,
  )

  const body = _get(res, 'body', {})
  const results = {
    ...body,
    currentPage: _get(body, 'currentPage') + 1,
  }
  return results
}

export async function getRecentlyWatchedPlaylist ({ auth, page = 1, limit }) {
  // Endpoint pagination returns 0 as the first page by default.
  // We do not want user's to see this so we control the offset here
  const offsetPage = page - 1

  const res = await apiGet('/v2/user/recently-watched',
    { p: offsetPage, pp: limit },
    { auth },
    TYPE_BROOKLYN_JSON,
  )

  const body = _get(res, 'body', {})
  const results = {
    ...body,
    currentPage: _get(body, 'currentPage') + 1,
  }
  return results
}
